<template>
	<span aria-hidden="true" class="kova-lp-stars" :class="`kova-lp-stars_tone_${tone}`">
		<template v-if="tone === 'light'">
			<InlineSvg v-for="star in 4" :key="star" class="kova-lp-stars__star" :src="starLight" />
			<InlineSvg class="kova-lp-stars__star" :src="starLightPartial" />
		</template>
		<template v-else>
			<img alt="" class="kova-lp-stars__star" :src="starFilled" />
			<img alt="" class="kova-lp-stars__star" :src="starFilled" />
			<img alt="" class="kova-lp-stars__star" :src="starFilled" />
			<img alt="" class="kova-lp-stars__star" :src="starFilled" />
			<img alt="" class="kova-lp-stars__star" :src="starPartial" />
		</template>
	</span>
</template>

<script>
import starFilled from '@/assets/kova/landing/star-filled.svg'
import starLight from '@/assets/kova/landing/star-light.svg'
import starLightPartial from '@/assets/kova/landing/star-light-partial.svg'
import starPartial from '@/assets/kova/landing/star-partial.svg'

// The 4.8 rating row shared by the landing header (mobile) and hero (desktop):
// four solid stars plus the two-tone partial one, exactly as in Figma 4841:21129.
// Callers size it by setting a height on the root; the stars keep their ratio.
export default {
	name: 'LandingKovaStars',

	props: {
		// `default` — the brand's two-tone gold, for light surfaces. `light` — one colour
		// over a coloured pill (USA rating, 6346:46353): the stars take the caller's
		// `color`, and the partial star's tail its `--kova-lp-stars-tail-opacity`.
		tone: {
			type: String,
			default: 'default',
			validator: (value) => ['default', 'light'].includes(value),
		},
	},

	setup() {
		return { starFilled, starLight, starLightPartial, starPartial }
	},
}
</script>

<style lang="scss" scoped>
.kova-lp-stars {
	display: flex;
	align-items: center;
	gap: var(--size-2);
}

.kova-lp-stars__star {
	display: block;
	width: auto;
	height: 100%;
}

// Inline SVGs do not size themselves from their viewBox the way an <img> does.
.kova-lp-stars_tone_light .kova-lp-stars__star {
	aspect-ratio: 17 / 16;
}

.kova-lp-stars_tone_light :deep(.kova-lp-stars__tail) {
	opacity: var(--kova-lp-stars-tail-opacity, 0.4);
}
</style>
